import { useState } from "react";

import { down, time } from "../../../utils";
import { Data, data } from "./mockedCourseData/data";
import "./Course.css";
// import Ticker from 'react-ticker'

const Course = () => {
  const [hideTicker, setHideTicker] = useState<boolean>(false);
  const [hideText, setHideText] = useState<boolean>(false);

  const toggleDaysVisibility = () => {
    setHideTicker(!hideTicker);
  };
  return (
    <>
      <div className="arrow_cover">
        <button onClick={toggleDaysVisibility} className={`arrow ${hideTicker ? 'active' : ''}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.70711 6.70711C6.31658 7.09763 5.68342 7.09763 5.29289 6.70711L0.292893 1.70711C-0.0976315 1.31658 -0.0976315 0.683417 0.292893 0.292893C0.683417 -0.097631 1.31658 -0.097631 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.097631 11.3166 -0.097631 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L6.70711 6.70711Z"
              fill="#040921"
            />
          </svg>
        </button>
      </div>

      <div className={`course ${hideTicker ? 'active' : ''}`}>
        <div className="ticker-wrap">
          <div className="ticker">
            <span className="item-collection">
              {data.map((crypto: Data, idx) => (
                <div key={crypto.cryptoName + " " + (idx+1) } className="crypto">
                  <img src={crypto.img} alt={crypto.alt} width="16px" height="16px" />
                  <div className="crypto_name">{crypto.cryptoName}</div>
                  <div className="crypto_balance"><p>{crypto.cryptoBalance}</p></div>
                  <div className="crypto_status" style={{ color: `${crypto.cryptoStatus === down ? "rgba(232, 99, 70, 1)" : "rgba(3, 177, 51, 1)"}` }}>
                    <img
                      src={crypto.cryptoStatus}
                      width="6px"
                      height="6px"
                      alt="course going down"
                    />
                    <div><p>{crypto.cryptoPercent}</p></div>
                  </div>
                </div>
              ))}
            </span>
            <span className="item-collection-2">
              {data.map((crypto: Data, idx) => (
                <div key={crypto.cryptoName + " " + idx} className="crypto">
                  <img src={crypto.img} alt={crypto.alt} width="16px" height="16px" />
                  <div className="crypto_name">{crypto.cryptoName}</div>
                  <div className="crypto_balance">{crypto.cryptoBalance}</div>
                  <div className="crypto_status" style={{ color: `${crypto.cryptoStatus === down ? "rgba(232, 99, 70, 1)" : "rgba(3, 177, 51, 1)"}` }}>
                    <img
                      src={crypto.cryptoStatus}
                      width="6px"
                      height="6px"
                      alt="course going down"
                    />
                    <div>{crypto.cryptoPercent}</div>
                  </div>
                </div>
              ))}
            </span>
          </div>
        </div>


        <div className={hideText ?  "tickerTime" : "textVisibility tickerTime"}>
          <p >Data delayed by 15 min</p>
          <img src={time} alt="time" width="20px" height="20px" onClick={() => { setHideText((prevState) => !prevState) }} />
        </div>
      </div>
    </>
  );
};

export default Course;
